import classNames from 'classnames';
import s from './index.module.css';

const Image = ({
    path,
    href = '',
    align = 'center',
    width,
}) => {
    if(!path) return <></>;

    return (
        <div className={
            classNames(
                        s.imageWrapper, 
                        {[s.left]: align === 'left'},
                        {[s.right]: align === 'right'}
                    )
        }>
            {
                !!href && 
                    <a style={{width: width ? `${width}%` : 'auto'}} target='_blank' className={s.image} href={href}>
                        <img alt='' src={path} />
                    </a>
            }
            {
                !href && 
                    <div style={{width: width ? `${width}%` : 'auto'}} className={s.image}>
                        <img alt='' src={path} />
                    </div>
            }
        </div>
    );
}

export default Image;